import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { renderProgramCard } from "../utils/render-program-card";
import { Title, Section } from "@vshp/ui-components";
import { fetchPrograms, fetchProgramsDegrees } from "../../actions/programs";

function ProgramsPopular({ programId }) {
  const { programs, programsDegrees, programsDegreesAreLoading } = useSelector((state) => state.programs);
  const dispatch = useDispatch();
  const [programsPopular, setProgramsPopular] = useState(null);

  useEffect(() => {
    if (programs.length === 0) {
      dispatch(fetchProgramsDegrees());
      dispatch(fetchPrograms());
    }
  }, [dispatch]);

  useEffect(() => {
    if (programs.length > 0) {
      setProgramsPopular(programs.filter((program) => parseInt(program.id, 10) !== parseInt(programId, 10)));
    }
  }, [programs]);

  return (
    programs.length > 0 &&
    !programsDegreesAreLoading &&
    programsDegrees.length > 0 && (
      <Section>
        <Title type="h2">ПОПУЛЯРНЫЕ ПРОГРАММЫ ОБУЧЕНИЯ</Title>
        {programsPopular && <div className="programs-feed__wrapper">{renderProgramCard(_.sampleSize(programsPopular, 3))}</div>}
      </Section>
    )
  );
}

export default ProgramsPopular;
